var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"pie",staticClass:"chart-legend-80",attrs:{"height":"600","type":"pie","options":_vm.options,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }